
import {get} from 'lodash-es'

import {axios} from 'helpers/axios'
import Store from 'models/Store'
import RoleOption from 'models/RoleOption'

const mixin = {
  state() {
    return {
      status: null,
      config: {},

      stores:      [],
      roleOptions: [],
      holidays:    [],

      maintenanceMessage:    null,
      maintenanceRetryAfter: null,
    }
  },

  mutations: {
    status(state, value) {state.status = value},
    config(state, value) {state.config = value},

    stores     (state, value) {state.stores      = value},
    roleOptions(state, value) {state.roleOptions = value},
    holidays   (state, value) {state.holidays    = value},

    maintenanceMessage   (state, value) {state.maintenanceMessage    = value},
    maintenanceRetryAfter(state, value) {state.maintenanceRetryAfter = value},
  },

  actions: {
    async fetchConfig({commit, dispatch}) {
      const {data} = await axios.get('/api/config')

      commit('status', data.auth == null ? 'auth' : 'main')
      commit('config', data)

      const stores = get(data, 'stores', []).map(store => new Store(store))
      commit('stores', stores)
      commit('roleOptions', RoleOption.make(stores))

      const holidays = get(data, 'holidays', []).reduce((a, v) => ({...a, [v.date]: v}), {})
      commit('holidays', holidays)

      // date
      await dispatch('updateDate', data.date)
    },
  },
}

export default mixin
